import { NSB_MENSAJE_REM } from "../../const/actionTypes";
export const RemMensaje = (payload) => ({
  type: NSB_MENSAJE_REM,
  payload,
});
